import React from 'react';
import { useSelector } from 'umi';
import GuideDashboardBox from './GuideDashboardBox';
import GuideIntelligenceBox from './GuideIntelligenceBox';
import {
  GUIDE_SYS_DASHBOARD,
  GUIDE_SYS_OPINION,
  GUIDE_SYS_INTELLIGENCE,
} from '@/pages/home/models/guide';
import GuideOpinionBox from './GuideOpinionBox/GuideOpinionBox';

export default () => {
  const { guideSys } = useSelector((state: any) => {
    const {
      guide: { guideSys },
    } = state;
    return {
      guideSys,
    };
  });
  return (
    <>
      {guideSys === GUIDE_SYS_DASHBOARD && <GuideDashboardBox />}
      {guideSys === GUIDE_SYS_OPINION && <GuideOpinionBox />}
      {guideSys === GUIDE_SYS_INTELLIGENCE && <GuideIntelligenceBox />}
    </>
  );
};
